const ROUTES = {
  LOGIN: "/login",
  SIGN_UP: "/sign-up",
  FORGOT_ACCESS: "/forgot-access",
  DASHBOARD: "/dashboard",
  LOYALTY: "/loyalty",
  ADD_LOYALTY: "/loyalty/add",
  REWARDS: "/rewards",
  ADD_REWARD: "/rewards/add",
  OFFERS: "/offers",
  ADD_OFFER: "/offers/add",
  CAMPAIGNS: "/campaigns",
  ADD_CAMPAIGN: "/campaigns/add",
  DIETARY: "/dietary",
  ADD_DIETARY: "/dietary/add",
  USERS: "/users",
  ADD_USER: "/users/add",
  SAMPLE:"/sample",
} as const;

export default ROUTES;
